import dynamic from 'next/dynamic';
import css from './index.module.scss';
import PageLayout from '@/components/PageLayout';
import { useGlobal } from '@/utils/useGlobal';
import PageConPc from '@/components/PowerOcean/Collection';
import PageConPc_DE from '@/components/PowerOcean/Collection/VersionDE';
import PageConH5 from '@/componentsH5/PowerOcean/Collection';
import PageConH5_DE from '@/componentsH5/PowerOcean/Collection/VersionDE';
import SEOlinksA from '@/components/SEOlinksA';
import FixedIcon from '@/components/FixedIcon';

export default function Page({ SEO }: any) {
    const { isMobile, useRouter, useLang, useEffect } = useGlobal();
    const router = useRouter();
    const { t } = useLang('poweroceancollection');
    const { locale } = router;
    const PageCon = isMobile ? (locale === 'de' ? PageConH5_DE : PageConH5) : locale === 'de' ? PageConPc_DE : PageConPc;
    const theme = '';
    const GtmPageLoad = dynamic(() => import('@/components/GtmPageLoad'), { ssr: false });
    useEffect(() => {
        if (!['eu', 'de', 'uk'].includes(locale)) {
            router.push('/404');
        }
    }, [locale, router]);

    return (
        <>
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA list={['eu', 'de', 'uk']} locale={locale} pathname={'home-solutions'} />
            <GtmPageLoad />
            <PageLayout className={`${css.productcontent} ${theme} product_common product_common_real`} theme={theme}>
                <PageCon />
            </PageLayout>
            <FixedIcon />
        </>
    );
}
